export const otherPayrollCostsSelector = (state) => ({
  fields: state.form?.forgivenessPage3?.fields,
  values: state.form?.forgivenessPage3?.values,
  syncErrors: state.form?.forgivenessPage3?.syncErrors,
  standardCoveredPeriodStartDate: state.form?.forgivenessPage1?.values?.standardCoveredPeriodStartDate,
  standardCoveredPeriodEndDate: state.form?.forgivenessPage1?.values?.standardCoveredPeriodEndDate,
});
